import './header.sass';
import { Container, Image, Nav, Navbar } from 'react-bootstrap';
import nobel_logo from '../../assets/images/nobel_logo.png';
import { useTranslation } from 'react-i18next';
import { TranslateComponent } from '../translate/translate-component';
import { Link as ScrollLink } from 'react-scroll';
import { NavLink, useNavigate } from 'react-router';

const nobel_url = '/';

function Header() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const headerLinks = [
    { title: t('home_title'), sectionId: nobel_url },
    { title: t('about_title'), url: 'about' },
    { title: t('contact_title'), sectionId: 'contact' },
    { title: t('help'), sectionId: 'faq' },
  ];

  // Function to handle the click and navigate to the correct page or section
  const navigateLinks = (link: { url?: string; sectionId?: string }) => {
    if (link.url) {
      navigate(`/${link.url}`);
    } else if (link.sectionId) {
      navigate(nobel_url);
      // Scroll to the section once on the home page
      setTimeout(() => {
        const scrollTarget = document.getElementById(link.sectionId || ''); // Ensure sectionId is a valid string
        if (scrollTarget) {
          scrollTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 300); // Add delay to ensure the page navigation completes before scrolling
    }
  };

  return (
    <Navbar collapseOnSelect expand="lg" className="header-container">
      <Container fluid>
        {/* Logo Section */}
        <Navbar.Brand className="header-logo">
          <div className="div_nobel">
            <a href={nobel_url} className="nobel-url">
              <Image
                src={nobel_logo}
                className="nobel-logo-header"
                alt="nobel-logo"
                fluid
              />
              <div className="nobel-title">Nobel</div>
            </a>
          </div>
        </Navbar.Brand>

        {/* Hamburger Toggle */}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="responsive-navbar-nav"
        />

        {/* Collapsible Navbar */}
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-center"
        >
          {/* Centered Navigation Links */}
          <Nav className="header-links">
            <hr className="navbar-hr" />
            {headerLinks.map((link, index) => (
              <div key={index}>
                {link.url ? (
                  // If the link has a URL, use NavLink for navigation
                  <NavLink
                    to={`/${link.url}`} // Use NavLink for navigation to other pages
                    className={({ isActive }) =>
                      isActive ? 'header-link active' : 'header-link'
                    }
                    onClick={() => navigateLinks(link)} // Handle click for routing
                  >
                    {link.title}
                  </NavLink>
                ) : (
                  // If the link is a section ID, use ScrollLink to scroll within the page
                  <ScrollLink
                    to={link.sectionId || ''}
                    smooth={true} // Enable smooth scrolling
                    spy={true} // Track active section as you scroll
                    duration={300} // Duration of the scroll (in ms)
                    activeClass="active" // Add active class to the link when section is in view
                    offset={-100}
                    className="header-link"
                    onClick={() => navigateLinks(link)} // Trigger custom logic
                  >
                    {link.title}
                  </ScrollLink>
                )}
              </div>
            ))}
          </Nav>

          {/* Button & Translate Component */}
          <Nav className="header-button-col">
            <ScrollLink
              to="provider"
              smooth={true}
              spy={true}
              duration={500}
              activeClass="active"
              className="header-link"
              offset={-100}
            >
              <button className="button-header">
                {t('become_our_partner')}
              </button>
            </ScrollLink>
          </Nav>
        </Navbar.Collapse>

        <div className="translate-component-container">
          <TranslateComponent />
        </div>
      </Container>
    </Navbar>
  );
}

export { Header };
